<template>
<div v-show="isModalVisible">
  <div class="modal-mask" @click="closeModal">
    <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <button type="button" class="close float-right" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
          <div class="row arrow_icons">
            <div class="reps_prev">
              <a href="javascript:void(0);" v-if="(index > 0)" @click="getNextPrev('Previous')">
                <i class="fa fa-angle-left"></i>
              </a>
            </div>
            <div class="reps_next">
              <a href="javascript:void(0);" v-if="((repCount > 1) && (parseInt(index + 1) < repCount))" @click="getNextPrev('Next')">
                <i class="fa fa-angle-right"></i>
              </a>
            </div>
          </div>
          <div class="modal-heading">
              <h5 class="col-12 modal-title">Review Reps ({{parseInt(index + 1) + '/' + repCount}})</h5>
              <h6 class="col-12 mentee_name">{{ menteeFirstName + ' ' + menteeLastName }}</h6>
              <hr/>
          </div>
          <div class="modal-sub-heading">
            <div class="sub-heading-label">Date: <span>{{ repCreatedAt | format1Date }}</span></div>
            <div class="sub-heading-label ml-4">Time: <span>{{ repCreatedAt | format2Date }} - CST</span></div>
          </div>
          <div class="modal-task-heading">
            <div class="sub-heading-label">Task List: <span>{{ taskListName }}</span></div>
            <div class="sub-heading-label">Task: <span>{{ taskName }}</span> </div>
          </div>
          <div class="review-form">
            <div v-show="submit_form_errors" class="validate-warning-msg-login">{{ submit_form_errors }}</div>
            <form v-if="status == 0">
              <div class="form-group row">
                <label class="col-12 form-label">Mentee Submitted Task Time: </label>
                <div class="col-12">
                  <date-picker 
                    name="Time spent on task"
                    v-model="display_time" 
                    type="time" 
                    format="HH:mm"
                    placeholder="Hours:Minutes"
                    :popup-style="timePickerStyle"
                    @change="inputHandler"
                    v-bind:clearable="false"
                    v-bind:editable="false"
                    ref="timepicker">
                  </date-picker>
                </div>
              </div>
              <div class="form-group row" v-if="subtaskId != 99999">
                <label class="col-12 form-label">Update Competency Rating?:</label>
                <div class="col-12">
                  <select 
                      name="Rate This Repetition"
                      v-validate="'required'" 
                      v-model="score" 
                      class="form-control">
                      <option value="">Select Rating</option>
                      <option v-for="(item, index) in items_options" :key="index" :value="item.value">{{ item.display }}</option>
                  </select>
                  <div v-if="verrors.firstByRule('Rate This Repetition', 'required')" :class="'validate-warning-msg ' + vmessage">Rate This Repetition is required</div>
                </div>
              </div>
              <div class="form-group row" v-if="mentee_comments && subtaskId != 99999">
                <div class="col-12">
                  <b>Mentee Comment: </b>  {{ mentee_comments }}                
                </div>
              </div>

              <div class="form-group row" v-if="commentsShow == 0 && subtaskId != 99999">
                <a href="javascript:void(0);" class="col-12 form-label show_comment" @click="commentsShow = 1">+ Add Comment for Mentee</a>
              </div>
              <div class="form-group row" v-if="commentsShow == 1 && subtaskId != 99999">
                <label class="col-12 form-label">Comment for mentee:</label>
                <div class="col-12">
                  <textarea 
                    name="Comment for mentee"
                    class="form-control"
                    v-model="comments"
                    placeholder="Enter Comment for Mentee"
                    maxLength="180"
                    @blur="characterCount"
                    @input="characterCount">
                  </textarea>
                  <span class="hint">{{ this.remainCharacters + ' Characters' }}</span>
                </div>
              </div>
              <div class="row center_div">
                <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-4">
                  <button type="button" class="btn btn-sm btn-blue denyBtn" @click="onSubmit('Denied')">Deny</button>
                </div>
                <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-4">
                  <button type="button" class="btn btn-sm btn-blue approveBtn" @click="onSubmit('Approved')">Approve</button>
                </div>
              </div>
            </form>
            <hr class="custom_hr">
            <div class="reps_history_label">
              <a href="javascript:void(0);" @click="showRepsHistory">
                See Repetition History for this task <i :class="toggleFontIcon" style="font-size: 18px;"></i>
              </a>
            </div>
            <RepetitionHistory 
              :menteeId="menteeId"
              :tasklistId="tasklistId"
              :taskId="this.taskId"
              ref="reps_history"
              parent_form="review_reps"
            >
            </RepetitionHistory>
          </div>
      </div>
      <div class="modal-footer">
        <h5 class="col-12 modal-title">Review Reps ({{parseInt(index + 1) + '/' + repCount}})</h5>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import RepetitionHistory from './repetition_history';

const today = new Date();
today.setHours(0, 0, 0, 0);

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});
Vue.filter('format1Date', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
});
Vue.filter('format2Date', function(value) {
  if (value) {
    return moment(String(value)).format('h:mm a')
  }
});

export default {
  props: [
    'isModalVisible',
    'menteeId',
    'menteeIndex',
    ],
  data() {
    return {
      timeOnTask: '',
      comments: '',
      mentee_comments: '',
      score_selected: '',
      items: [],
      items_options: [],
      taskListName: '',
      taskId: '',
      subtaskId: '',
      tasklistId: '',
      repId: '',
      taskName: '',
      menteeFirstName: '',
      menteeLastName: '',
      repCount: 0,
      index: 0,
      repTasks: [],
      status: 0,
      shours: 0,
      sminutes: 0,
      remainCharacters: 180,
      commentsShow: 0,
      repCreatedAt: '',
      display_time: '',
      score: '',
      rep_count: '',
      timePickerStyle: {},
      submit_form_errors: '',
      toggleFontIcon: 'fa fa-angle-down',
      vmessage: '',
    }
  },
  methods: {
    closeModal() {
      this.index = 0;
      this.commentsShow = 0;
      this.remainCharacters = 180;
      this.comments = '';
      this.score = '';
      this.$refs.reps_history.hideRepsHistory();
      this.$validator.errors.clear();
      this.$parent.allItems[this.menteeIndex].rep_count = this.repCount;
      this.$emit('close');
    },
    characterCount: function() {
      if(this.comments.length > 0){
        this.remainCharacters = 180 - this.comments.length;
      }
    },
    getScoreLists(msg) {
      // console.log(item);
      this.vmessage = msg;
      this.items_options = [];
      axios.get('/score-lists', {
      })
      .then(response =>  {
        this.score_selected = '';
        var scores = response.data;

        for(var i=0; i<scores.length; i++) {
          this.items_options.push({
            value: scores[i].value,
            display: scores[i].text,
          });
        }
      })
      .catch(() => {
      });


      this.timePickerStyle['left'] = '50%';
      this.timePickerStyle['top'] = '50%';
      this.timePickerStyle['transform'] = 'translate(-30%, -60%)';
      this.timePickerStyle['z-index'] = '9999';
    },
    inputHandler(eventData) {
      var d = new Date(eventData);
      var hours = d.getHours();
      var mins = d.getMinutes();
      let hourMins = hours*60;
      this.timeOnTask = hourMins + mins;
      if (hours >= 0 && mins > 0) {
       this.$refs.timepicker.closePopup();
      }
    },
    getPendingReviews(item) {
      // console.log(item);
      this.rep_count = item;
    },
    getNextPrev: function(type) {
      this.status = 0;
      this.vmessage = "hide_vmessage";
      if(type == 'Next') {
        this.index = parseInt(this.index + 1);
        if(this.index == this.repCount) {
          this.index = parseInt(this.index - 1);
        }
      }
      else if (type == 'Previous') {
        this.index = parseInt(this.index - 1);
        if(this.index < 0) {
          this.index = parseInt(this.index + 1);
        }
      }
      this.$refs.reps_history.hideRepsHistory();
      this.getRepValueFromIndex();
    },
    getRepValueFromIndex: function() {
      this.timeOnTask = this.repTasks[this.index].minutes;
      this.comments = this.repTasks[this.index].comments;
      this.mentee_comments = this.repTasks[this.index].menteeComment;
      this.taskName = this.repTasks[this.index].taskName;
      this.taskId = this.repTasks[this.index].taskId;
      this.subtaskId = this.repTasks[this.index].subtaskId;
      this.tasklistId = this.repTasks[this.index].taskListId;
      this.taskListName = this.repTasks[this.index].taskListName;
      this.repId = this.repTasks[this.index].repId;
      this.status = this.repTasks[this.index].status;
      this.repCreatedAt = this.repTasks[this.index].createdAt;
      this.score = '';
      this.comments = '';
      this.commentsShow = 0;
      this.remainCharacters = 180;
      if(this.timeOnTask > 0) {
        var hours = (this.timeOnTask / 60);
        var rhours = Math.floor(hours);
        this.shours = rhours;
        this.sminutes = Math.round((hours - rhours) * 60);
        if(this.sminutes > 0) {
          this.display_time = new Date();
          this.display_time.setHours(this.shours);
          this.display_time.setMinutes(this.sminutes);
        }
        else {
          this.display_time = new Date();
          this.display_time.setHours(this.shours);
          this.display_time.setMinutes('00');
        }
      }
    },
    getMenteeRepetitionList(menteeId) {
      axios.get('/desktop/get-mentee-repitition-lists-all-tasklists', {
        params: {
          mentee_id: menteeId,
          accountId: this.$store.state.user_accountid
        }
      })
      .then(response =>  {
        this.menteeFirstName = response.data.mentee_first_name;
        this.menteeLastName = response.data.mentee_last_name;
        this.repCount = response.data.rep_count;
        this.repTasks = response.data.rep_tasks;
        this.timeOnTask = this.repTasks[this.index].minutes;
        this.mentee_comments = this.repTasks[this.index].menteeComment;
        this.comments = this.repTasks[this.index].comments;
        this.taskName = this.repTasks[this.index].taskName;
        this.taskId = this.repTasks[this.index].taskId;
        this.subtaskId = this.repTasks[this.index].subtaskId;
        this.tasklistId = this.repTasks[this.index].taskListId;
        this.taskListName = this.repTasks[this.index].taskListName;
        this.repId = this.repTasks[this.index].repId;
        this.status = this.repTasks[this.index].status;
        this.getRepValueFromIndex();
      })
      .catch(() => {

      });
    },
    showRepsHistory() {
      this.$refs.reps_history.fetchRepsHistory();
    },
    onSubmit(type) {
      this.vmessage = "show_vmessage";
      this.$validator.validateAll().then((result) => {
        if(!result){
            return;
        }
        this.saveReviewRepetition(type)
      }).catch(() => {
          // catches the error;
      });
    },
    saveReviewRepetition(type) {
      this.$refs.reps_history.hideRepsHistory();
      axios('/desktop/mentor-approval-mentee-repitition',
        {
          method: 'POST',
            data: {
            "mentee_id" : this.menteeId,
            "taskListId": this.tasklistId,
            "rep_id": this.repId,
            "time_on_task": this.timeOnTask,
            "comments": this.comments,
            "type": type,
            "score": this.score,
            "account_id": this.$store.state.user_accountid,
          }
        },
        )
        .then(()=> {
          this.vmessage = "hide_vmessage";
          var findIndex = 0;
          var currentIndex = this.index + 1;
          if (parseInt(this.repCount) === parseInt(currentIndex)) {
            this.index = 0;
            findIndex = this.repCount - 1;
          } else {
            if (currentIndex == 1) {
              findIndex = parseInt(currentIndex - 1);
            } else {
              findIndex = currentIndex - 1;
            }
          }
          if (this.repCount > 0) {
            if(this.$parent.allItems[this.menteeIndex].id == this.menteeId) {
              this.$parent.allItems[this.menteeIndex].rep_count -= 1;
            }
            this.repCount -= 1;
          }
          if (this.repCount == 0) {
            this.index = parseInt(this.index - 1);
            this.closeModal();
          }
          this.repTasks.splice(findIndex, 1);
          this.getRepValueFromIndex();
        })
        .catch(() => { 
        });
    },
  },
  components: {
    DatePicker,
    RepetitionHistory,
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: 620px;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-body {
  margin: 0px;
  padding: 10px;
  color: #002F42;
}
.modal-footer {
  padding: 0px;
  margin: 30px 0;
  text-align: center;
}
.modal-header {
  padding: 0px;
  border-bottom: 0 none;
  margin-bottom: 10px;
}
.modal-header .close {
  padding: 5px;
}
.modal-heading {
  text-align: center;
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  bottom: 0;  
  height: 35px;
}
.modal-heading hr { margin-top: 0; }
.modal-sub-heading {
  padding: 0px;
  margin-top: 25px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
}
.sub-heading-label {
  font-weight: 900;
}
.sub-heading-label span {
  font-weight: normal;
}
.modal-task-heading {
  padding: 0px;
  margin-bottom: 10px;
}
.modal-task-heading .sub-heading-label { margin: 10px 0;}
.modal-footer {
  border-top: none;
}
.modal-title {
  color: #002F42;
  font-size: 14px;
  font-weight: 900;
}
.review-form {
  padding: 5px;
  font-size: 13px;
  color: #002F42;
}
.goal_input {
  border: 2px solid #ddd !important;
  border-radius: 5px !important;
}
.modal-body {
  padding: 5px;
}
.form-label {
  font-weight: 900;
  padding: 0.375rem 0.75rem;
}
.form-label span {
  font-weight: normal;
}
.center_div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.denyBtn, .denyBtn:active, .denyBtn:focus {
  color: #29A3E4 !important;
  background-color: #FFF !important;
  border: 1px solid #29A3E4 !important;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 900;
  padding: 10px;
  line-height: 8px;
  width: 140px;
}
.approveBtn {
  color: #FFF; 
  background-color: #29A3E4 !important;
  border: 1px solid #29A3E4 !important;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 900;
  padding: 10px;
  line-height: 8px;
  width: 130px;
}
.reps_history_label a, .reps_history_label a:active, .reps_history_label a:focus {
  color: #002F42 !important;
  text-decoration: none !important;
}
.reps_history_label { 
  text-align: center; 
  font-weight: bold; 
  margin: 0 auto;
}
.custom_hr {
  border-bottom: 1px solid #e8e8e8;
  width: 60%;
}
.mx-datepicker { width: 100%; }
.form-control { font-size: 14px; }
.hint { float: right; }
.mentee_name { font-size: 14px; }
.show_comment {
  text-align: right;
  text-decoration: none !important;
}
.reps_prev {
  min-height: 40px;
  text-align: left;
  width: 50%;
}
.reps_next i, .reps_prev i { 
  font-size: 30px; 
  margin: 5px 0;
}
.reps_next {
  min-height: 40px;
  text-align: right;
  width: 50%;
}
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
/* Iphone 5 */
@media (min-width: 320px) and (max-width: 576px) { 
  .modal-container {
    top: 54%;
  }
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
  .denyBtn, .denyBtn:active, .denyBtn:focus, .approveBtn, .approveBtn:active, .approveBtn:focus { 
    width: 100%; 
  }
}
/* Ipad Landscape */
@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) { 
  .denyBtn, .denyBtn:active, .denyBtn:focus, .approveBtn, .approveBtn:active, .approveBtn:focus {
    width: 100%; 
  }
}
/* Ipad Pro portrait */
@media only screen and (min-device-width : 1024px) and (max-device-width : 1366px) and (orientation : portrait) { 
  .denyBtn, .denyBtn:active, .denyBtn:focus, .approveBtn, .approveBtn:active, .approveBtn:focus {
    width: 100%; 
  }
}
</style>



// WEBPACK FOOTER //
// src/components/manager/MenteeReviewRepetitionAllTasklists.vue